<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Contacts"
                createIconText="Ajouter un contact"
                importDatasourceName="contacts"
                (created)="onContactCreated()"
                (exported)="onContactsExported()"
                (imported)="onContactsImported()"
                (helped)="onContactsHelped()"></app-list-header>
        </mat-expansion-panel-header>
        <app-contacts-list
            #itemsList
            (itemSelected)="onContactSelected($event)"
            (itemDisplayed)="onContactDisplayed($event)"
            (itemEdited)="onContactEdited($event)"
            (itemDeleted)="onContactDeleted($event)"
            (itemDuplicated)="onContactDuplicated($event)"></app-contacts-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onContactDisplayed(context?.formContext.item)"
                    (edited)="onContactEdited(context?.formContext.item)"
                    (helped)="onContactsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-contact-detail [context]="context" (contactUpdated)="contactUpdated($event)" (canceled)="onBackToList()"></app-contact-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
